import { animate, style, transition, trigger } from '@angular/animations';

export class FadeInAnimator {
  private static triggerName = 'fadeIn';

  public static fade  = (durationInMillis = 300) => trigger(FadeInAnimator.triggerName, [
    transition('* => *', [
      style({ opacity: 0 }),
      animate(`${durationInMillis}ms ease-out`, style({ opacity: 1 }))
    ])
  ]);
}
